<div
    class="tabs tab-{{ appearance }}"
    [class.display-margin-bottom]="shouldDisplayMarginBottom"
    [attr.role]="'tablist'"
    [attr.aria-label]="ariaLabel">
    @for (tab of tabs; track tab; let i = $index) {
    <button
        [attr.role]="'tab'"
        [id]="tab.tabId"
        class="tab-title-selector tab-{{ appeal }}"
        [class.tab-disabled]="!tab.active"
        [class.keyboard-navigation]="isKeyboardNavigation$ | async"
        [class.tab-selected]="tab.display"
        [ngStyle]="{
            '--border-height': separatorHeight,
        }"
        [attr.aria-selected]="tab.display"
        [attr.tabindex]="isFocusable(tab.display, i)"
        [attr.aria-controls]="getAriaControls(tab)"
        [attr.aria-posinset]="i + 1"
        [attr.aria-setsize]="tabs.length"
        (click)="onClickTab(tab)"
        (keydown)="onKeyDown($event)"
        #tabTitle>
        @if (tab.customTabTitle.length > 0) {
        <div [class.tab-underline]="tab.display" class="tab-custom-title">
            <div class="tab-title-container">
                <ng-container *ngTemplateOutlet="getTitleTemplate(tab); context: tab"></ng-container>
            </div>
        </div>
        } @else {

        <p [class.tab-underline]="tab.display" class="tab-title-text"> {{ tab.tabTitle }} </p>

        }
    </button>
    }
</div>
<div
    [class.tab-items-container]="shouldDisplayVerticalScrollbar"
    [@changeList]="changeListAnimation && appearance === 'list'"
    [@.disabled]="!changeListAnimation"
    (@changeList.done)="onAnimationEnd()">
    <ng-content></ng-content>
</div>
